// Module
var code = "<react-component name=\"GymsMetricsReport\"></react-component>\n";
// Exports
module.exports = code;